
                import "css-modules://src_components_button_button"
                export default {"Main":"_99e69b","Visible":"_fddc03","LinesTop":"_6e136d","LinesBottom":"_8c6aca","LinesLeft":"_4fb7dd","LinesRight":"_9218fa","Inner":"_c372fa","Label":"_fa69b6"}
            